module.exports = __webpack_public_path__ + "static/img/91BM-061-MaxMeng.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/91BM-061-MaxMeng.jpg
// module id = v3WC
// module chunks = 0